const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const handle = async (res) => {
  if (!res.ok) {
    throw new Error(res.status === 401 ? "Invalid admin key" : `Request failed (${res.status})`);
  }
  return res.json();
};

const withKey = (key) => ({ headers: { "X-Admin-Key": key } });

export const adminApi = {
  summary: (key) => fetch(`${API}/admin/summary`, withKey(key)).then(handle),

  visits: (key, visitorId) =>
    fetch(
      `${API}/visits${visitorId ? `?visitor_id=${encodeURIComponent(visitorId)}` : ""}`,
      withKey(key),
    ).then(handle),

  inquiries: (key, { status = "", q = "" } = {}) => {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    if (q) params.set("q", q);
    return fetch(`${API}/admin/inquiries?${params}`, withKey(key)).then(handle);
  },

  updateInquiry: (key, id, patch) =>
    fetch(`${API}/admin/inquiries/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-Admin-Key": key },
      body: JSON.stringify(patch),
    }).then(handle),

  deleteInquiry: (key, id) =>
    fetch(`${API}/admin/inquiries/${id}`, { method: "DELETE", ...withKey(key) }).then(handle),

  exportCsv: async (key) => {
    const res = await fetch(`${API}/admin/export`, withKey(key));
    if (!res.ok) {
      throw new Error(res.status === 401 ? "Invalid admin key" : `Export failed (${res.status})`);
    }
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "inquiries.csv";
    a.click();
    URL.revokeObjectURL(url);
  },
};
